// utils
import { codeGeneretor } from 'app/utils';
//class
import PadEditor from './PadEditor';

/**
 * represents an instance of PadEditorFurniture
 * @class PadEditorFurniture
 * @extends PadEditor
 */
export default class PadEditorFurniture extends PadEditor {
  prepare(furnitures = []) {
    const preparedFurnitures = furnitures.map(furniture => ({
      id: furniture.id,
      code: codeGeneretor(),
      amount: furniture.amount,
      type: furniture.type,
      itemId: furniture.itemId,
      unityPrice: furniture.unityPrice,
      name: furniture.furnitureName,
      status: furniture.status
    }));

    this._loadedData = preparedFurnitures;
    this._screenData = preparedFurnitures;

    return this;
  }
}
